<template>
  <div style="padding: 0 10px">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane v-for="com in comList" :label="com" :key="com" :name="com">
        <viewPage :type="com" :warehouseList="warehouseList" :forwarder="forwarder"/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import viewPage from "@/views/configure/shipWeightFree/components/viewPage";
import { warehouseList,forwarderList } from "@/apis/configure";
export default {
  title: "发货重量费用配置",
  name: "ConfigureShipWeightFree",
  components: {
    viewPage,
  },
  data() {
    return {
      activeName: "B2B",
      comList: ["B2B", "D2C"],
      warehouseList:[],
      forwarder:[]
    };
  },
  mounted() {
    this.getWarehouse();
    this.getForwarderList()
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    getWarehouse() {
      warehouseList().then(({ code, data }) => {
        if (code === 0) {
          this.warehouseList = data;
        }
      });
    },
    getForwarderList() {
      forwarderList().then(({code,data})=>{
        if(code === 0){
          this.forwarder = data;
        }
      })
    }
  },
};
</script>

<style scoped></style>
